function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { formatTime, secondsToMilliseconds } from "@common/services/helpers";
var MILLISECONDS_IN_MINUTE = 60 * 1000;
var Time = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(Time, PureComponent);
    var _super = _create_super(Time);
    function Time(props) {
        _class_call_check(this, Time);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            serverTime: props.serverTime ? props.serverTime.now : Math.round(new Date().getTime() / 1000)
        };
        _this.intervalID = null;
        _this.timeoutID = null;
        _this.tick = _this.tick.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(Time, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                // Set timeout with the remaining seconds to round minute,
                // call set interval on one minute after that.
                var millisecondsToRoundMinute = MILLISECONDS_IN_MINUTE - secondsToMilliseconds(new Date(secondsToMilliseconds(this.state.serverTime)).getSeconds());
                this.timeoutID = setTimeout(function() {
                    _this.tick();
                    _this.intervalID = setInterval(_this.tick, MILLISECONDS_IN_MINUTE);
                }, millisecondsToRoundMinute);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearInterval(this.intervalID);
                clearTimeout(this.timeoutID);
            }
        },
        {
            /**
     * Change time with 1 minute/60 seconds from previous
     */ key: "tick",
            value: function tick() {
                this.setState(function(prevState) {
                    return {
                        serverTime: prevState.serverTime + 60
                    };
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "time-wrapper text-center",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "city",
                            children: this.props.city
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "time",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "icon icon-clock"
                                }),
                                formatTime(this.state.serverTime)
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return Time;
}(PureComponent);
export default Time;
